import { Component, OnInit } from '@angular/core';
import { GatewayService } from 'src/app/gateway.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
//IMPORT POWERBI
import * as pbi from 'powerbi-client';
import { NgxPowerBiService } from 'ngx-powerbi';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { TipoServicioService } from '../tipo-servicio.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  private destroy$ = new Subject<void>();

	private powerBiService: NgxPowerBiService;
	private pbiContainerElement: HTMLElement;

	// Mapa idContrata -> nombre de contrata. Se carga una vez al init del dashboard
	// para supervisores por contrata (idrol 23/24). El nombre se usa como filtro
	// adicional sobre la tabla resumenCitas/contrata_tecnico_real en PowerBI.
	private contratasMap: { [id: number]: string } = {};

	constructor(
		private router: Router,
		private localSave: LocalSaveService,
		private gateway: GatewayService,
		private spinner: NgxSpinnerService,
		private _tipoServicio: TipoServicioService,
	) {
		this.powerBiService = new NgxPowerBiService();
	}

	ngOnInit() {
		const user = this.localSave.get('usuarioPGV');
		const tienePermiso = user && user.permisos && user.permisos.find(p => p.modulo === 'DASHBOARD' && p.permiso_ver === 1);
		if (!user || (user.idrol != 16 && user.idrol != 1 && user.idrol != 23 && user.idrol != 24 && user.idrol != 27 && !tienePermiso)) {
			this.router.navigate(['/home']);
		}

		// Si el usuario es supervisor por contrata (idrol 23 o 24), precargamos los
		// nombres de las contratas para poder filtrar PowerBI por resumenCitas/contrata_tecnico_real.
		// Hacemos dos llamadas (una por IDAREA) para que el endpoint no deduplique nombres
		// repetidos entre Instalaciones y Reparaciones (es decir, contrata + contrata.id_relacionado).
		if (user && (user.idrol === 23 || user.idrol === 24)) {
			Promise.all([
				this.gateway.get('getContrata', { IDAREA: 14 }),
				this.gateway.get('getContrata', { IDAREA: 15 })
			]).then((responses: any[]) => {
				responses.forEach((res: any) => {
					(res && res.rows || []).forEach((row: any) => {
						if (row && row.id) { this.contratasMap[row.id] = row.nombre; }
					});
				});
				// Re-disparar embed para que aplique el nuevo filtro si ya estabamos renderizados sin el nombre.
				this.showReport([]);
			}).catch(() => {});
		}

		this._tipoServicio.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.showReport([]);
		});
	}

	ngAfterViewInit() {
		this.showReport([
			{
				"agency_names": "'Albrook Mall', 'Costa del Este', 'Test '"
			}
		]);
	}

	showReport(agencyNames) {
		// Report's Secured Token
		let accessToken = '';

		// Embed URL
		// let embedUrl = 'https://embedded.powerbi.com/reportEmbed?';
		let embedUrl = 'https://app.powerbi.com/reportEmbed?';

		// Report ID
		//let embedReportId = '5d6b9cef-c5ac-4836-815f-082ba6914a6e';//isoft
		// let embedReportId = '49dab7a8-d9c5-4dcb-9a40-7350d8ea681f'; //mov desa
		let embedReportId = 'beea8fba-4abc-43e2-ba95-25cdbd66784f'; //mov prod

		// Group ID
		let embedGroupId = '1e41269c-5735-4eea-b24b-8471b8b980fe';

		this.gateway.get('gettokenbi', {}).then((result: any) => {
			// let auxres: any = result;
			// const config = {
			// 	type: 'report',
			// 	id: embedReportId,
			// 	embedUrl:
			// 		embedUrl +
			// 		'reportId=' + embedReportId +
			// 		'&groupId=' + embedGroupId,
			// 	accessToken: auxres.access_token,
			// 	settings: {
			// 		filterPaneEnabled: true,
			// 		navContentPaneEnabled: true
			// 	}
			// };

			const token = JSON.parse(result.TOKEN);
			// Aplicar filtros del dashboard segun el rol del usuario:
			//   - Distribuidores clasicos (esDistribuidor=true), rol 27 (esReadOnly) y roles
			//     dinamicos (idrol>=28): filtran SOLO por el toggle Instalaciones/Ambos/Reparaciones,
			//     usando contrata/iddistribuidor in (41/44/41,44).
			//   - Supervisores por contrata (idrol 23 y 24): filtran por el toggle Y por su
			//     contrata especifica (IDCONTRATA2). Ven solo sus citas dentro del area elegida.
			const _user = this.localSave.get('usuarioPGV') || {};
			const _aplicarFiltroDistribuidor = !!_user.esDistribuidor || _user.idrol === 27 || (typeof _user.idrol === 'number' && _user.idrol >= 28);
			const _esRolPorContrata = (_user.idrol === 23 || _user.idrol === 24) && _user.IDCONTRATA2;
			const idu = this._tipoServicio.getValorActual().IDU;
			const ids = idu === 0 ? '41,44' : idu;
			if (_esRolPorContrata) {
				// Para supervisores por contrata (idrol 23/24) aplicamos:
				//   - filtro por toggle Instalaciones/Ambos/Reparaciones via contrata/iddistribuidor
				//   - filtro por contrata especifica via agente/contrata_id; en "Ambos" incluye
				//     tanto la contrata principal como la id_relacionado del usuario
				//   - filtro adicional por NOMBRE de la contrata sobre resumenCitas/contrata_tecnico_real
				//     (la tabla resumenCitas usa nombre, no id; mismo nombre para ambas contratas)
				let contrataIdsClause;
				if (idu === 0) {
					// Ambos: incluir principal + alterna. La principal puede estar en IDCONTRATA2
					// (cuando no se hizo swap) o en _IDCONTRATA2_ORIGINAL (cuando se hizo swap).
					const idPrincipal = _user._IDCONTRATA2_ORIGINAL || _user.IDCONTRATA2;
					const idAlterna = _user.IDCONTRATA2_RELACIONADO;
					const setIds = [idPrincipal];
					if (idAlterna && idAlterna !== idPrincipal) { setIds.push(idAlterna); }
					contrataIdsClause = setIds.join(',');
				} else {
					contrataIdsClause = String(_user.IDCONTRATA2);
				}
				let filterExpr = `contrata/iddistribuidor in (${ids}) and agente/contrata_id in (${contrataIdsClause})`;
				const nombreContrata = this.contratasMap[_user.IDCONTRATA2];
				if (nombreContrata) {
					const _nombreEscaped = String(nombreContrata).replace(/'/g, "''");
					filterExpr += ` and resumenCitas/contrata_tecnico_real eq '${_nombreEscaped}'`;
				}
				embedUrl += `&filter=${filterExpr}`;
			} else if (_aplicarFiltroDistribuidor) {
				embedUrl += `&filter=contrata/iddistribuidor in (${ids})`;
			}

			const config = {
				type: 'report',
				id: result.REPORT,
				embedUrl: embedUrl,
				accessToken: token.access_token,
				tokenType: pbi.models.TokenType.Aad,
				settings: {
					filterPaneEnabled: false,
					navContentPaneEnabled: true
				}
			};

			this.pbiContainerElement = <HTMLElement>(document.getElementById('pbi-container'));
			// Si ya hay un report embebido en este container (porque cambiamos el toggle
			// Instalaciones/Ambos/Reparaciones), powerBiService.embed() lo reutiliza y NO
			// actualiza el embedUrl, dejando el iframe con el filter viejo. Hacemos reset()
			// para forzar que el siguiente embed cree un iframe nuevo con el filter actual.
			try {
				if ((<any>this.powerBiService).get && (<any>this.powerBiService).get(this.pbiContainerElement)) {
					(<any>this.powerBiService).reset(this.pbiContainerElement);
				}
			} catch (e) { /* noop */ }

			let report;
			try {
				report = <pbi.Report>this.powerBiService.embed(this.pbiContainerElement, config);
			} catch (embedErr) {
				return;
			}

			// Report.off removes a given event handler if it exists.
			report.off("loaded");

			// Report.on will add an event handler which prints to Log window.
			report.on("loaded", function () {
				// console.log("Loaded");
			});
		}).catch(function (e) {
		});
	}

	descargatodo() {
		this.spinner.show();
		this.gateway.get('exportaradmindashcount', {}).then(
			(data: any) => {
				if (data.rows[0].cantidad > 0) {
					this.prepararinformacion(data.rows[0].cantidad, 0, null);
				} else {
					//this.snackbar.open('No hay clientes para esta campaña.', 'Cerrar', { duration: 3000, });
					this.spinner.hide();
				}
			}
		);
	}

	prepararinformacion(count, index, data) {
		//console.log('==========')
		// console.log({ IDCAMPANA: campana, LIMIT: 100, OFFSET: index })
		// console.log('==========')
		this.gateway.get('exportaradmindashlote', { LIMIT: 1000, OFFSET: index }).then(
			(result: any) => {
				if (data) {
					data = data.concat(result.rows)
				} else {
					data = result.rows;
				}
				// console.log('==========')
				// console.log(data)
				// console.log('==========')
				let control = index + 1000;
				if (control <= count) {
					// console.log('==========')
					// console.log(control)
					// console.log('==========')
					this.prepararinformacion(count, control, data);
				} else {
					this.descargarexcel(data);
				}
			}
		);
	}

	descargarexcel(ctr) {
		const fileName = 'Data_dashboard-' + Date.now();
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ctr);
		XLSX.utils.book_append_sheet(wb, ws);

		const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
		saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
		this.spinner.hide();
	}


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
